/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    google: false,
    apple: false,
};
export const walletSlice = createSlice({
    name: 'walletReducer',
    initialState,
    reducers: {
        updateWalletState: (state, action) => {
            console.log(`Setting ${action.payload.type} to ${action.payload.value}`);
            state[action.payload.type] = !!action.payload.value;
        },
    },
});
export const { updateWalletState } = walletSlice.actions;
// eslint-disable-next-line max-len
export const setWalletState = (type, value) => (dispatch) => Promise.resolve(dispatch(updateWalletState({ type, value })));
export const getWalletGoogleState = (state) => state.wallet.google;
export const getWalletAppleState = (state) => state.wallet.apple;
export const getWalletState = (state) => ({
    apple: state.wallet.apple,
    google: state.wallet.google,
});
export default walletSlice.reducer;
